import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoint } from '../../Themes/screensize';
import { IThemePalette } from '../../Themes/interfaces';
import { defaultNormalTextCss } from '../../common/mixins';

export const radioColours = (palette: IThemePalette) => ({
  radio: {
    focus: {
      background: palette.primary.second[25],
      border: palette.primary.second[25]
    },
    invalid: {
      border: palette.alerts.alert
    }
  }
});

const commonRadioButtonActiveOrSelectedCss = css`
  background-color: ${({ theme }) => theme.colours.radio.focus.background};
  border-color: ${({ theme }) => theme.colours.radio.focus.border};
`;

const commonRadioButtonLabelCss = css`
  ${defaultNormalTextCss};
  font-style: normal;
  vertical-align: middle;
  text-align: center;
  cursor: pointer;
  background-color: ${({ theme }) => theme.colours.default.background};
  border: 1px solid ${({ theme }) => theme.colours.default.border};
  box-sizing: border-box;
  padding: 0.825rem 0.625rem;
  height: 3rem;
  border-radius: 0.25rem;
  margin: 0.5rem 0.25rem;
  :focus,
  :hover {
    ${commonRadioButtonActiveOrSelectedCss};
  }
  @media (max-width: ${breakpoint.mobile}) {
    height: 3rem;
    width: 9rem;
    margin: 0.25rem;
  }
`;

export const RadioButtonLabel = styled.label`
  ${commonRadioButtonLabelCss};
  width: 9rem;
`;

export const RadioButtonLabelSmall = styled.label`
  ${commonRadioButtonLabelCss};
  width: 6rem;
`;

export const RadioButtonGroup = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  @media (max-width: ${breakpoint.tablet}) {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    justify-items: center;
  }
  @media (max-width: ${breakpoint.mobileSmall}) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    justify-items: center;
  }
`;

export interface IRadioButtonProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  invalid?: boolean;
}

export const RadioButtonBase = styled.input.attrs({ type: 'radio' })<IRadioButtonProps>`
  display: none;
  text-align: center;
  :checked + ${RadioButtonLabel}, :checked + ${RadioButtonLabelSmall} {
    ${commonRadioButtonActiveOrSelectedCss};
  }

  ${({ invalid, theme }) =>
    invalid &&
    css`
      & ~ ${RadioButtonLabel}, & ~ ${RadioButtonLabelSmall} {
        border: 1px solid ${theme.colours.radio.invalid.border};
      }
    `}
`;

export const RadioButton = ({ invalid, ...props }: IRadioButtonProps) => {
  return <RadioButtonBase invalid={invalid} {...props} />;
};
